/* global axios */
import ApiClient from '../ApiClient';

// Teletel custom roles CRUD + per-agent assignment. Administrators only -
// the server enforces it; this client only mirrors the existing API.
class TeletelRolesAPI extends ApiClient {
  constructor() {
    super('roles', { accountScoped: true });
  }

  baseUrl() {
    return `/teletel${super.baseUrl()}`;
  }

  assign(userId, customRoleId) {
    const agentsUrl = this.url.replace(/\/roles$/, '/agents');
    return axios.patch(`${agentsUrl}/${userId}/role`, {
      custom_role_id: customRoleId,
    });
  }
}

export default new TeletelRolesAPI();
